import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => (
  <>
    <Helmet>
      <title>Terms of Service | Nayrix</title>
      <meta name="description" content="Read the terms of service for using Nayrix's website and services." />
      <meta property="og:title" content="Terms of Service | Nayrix" />
      <meta property="og:description" content="Read the terms of service for using Nayrix's website and services." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://nayrix.com/termsofservice" />
      <link rel="canonical" href="https://nayrix.com/termsofservice" />
    </Helmet>
    <div className="flex items-center justify-center min-h-[70vh] pt-16">
      <div className="w-full max-w-xl bg-white dark:bg-neutral-900 rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
        <p className="text-lg text-neutral-600 dark:text-neutral-300">
          By using this website, you agree to our terms. Nayrix provides information as-is and is not liable for any damages. For details, contact us.
        </p>
      </div>
    </div>
  </>
);

export default TermsOfService;